import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import StatementGuide from './StatementGuide/StatementGuide';

const Statement = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'Declaración', icon: 'icon-bookmark' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Nueva Declaración' links={breadcrumbLinks} icon={'icon-circle-plus'} />
					<StatementGuide/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Statement;